import React, { useState, FC } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { isUndefined, isNil } from "lodash";
// shared
import ModuleTitleBar from "Components/shared/module-title-bar";
import { UserCreationForm } from "Components/user-management/user-create-form";
// helpers
import { encode, toaster } from "Helpers/index";
// services
import { createUser } from "Services/user.services";
// types
import { UserCreationInput } from "Types/user.types";

const UserCreate: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleCreateCompanyUser = async (data: UserCreationInput) => {
    setIsLoading(true);

    const responseData = await createUser(data);

    if (responseData && isNil(responseData.error)) {
      toaster("success", t("toaster.userSuccessfullyCreated"));
      setIsLoading(false);
      history.push(`/user-management/users`);
    } else {
      toaster("error", t("error.failedToCreate", { field: t("label.user") }));
      // console.error(responseData.error);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>{t("pageTitle.createUser")}</title>
      </Helmet>

      <ModuleTitleBar
        titleText={t("title.userManagement")}
        haveSubtitle
        subtitleText={t("title.user")}
      />

      <UserCreationForm
        onBack={() => {
          history.goBack();
        }}
        onSubmitCreationForm={handleCreateCompanyUser}
        isLoading={isLoading}
      />
    </div>
  );
};

export default UserCreate;
